var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"top_box"},[_c('LeftBoxVue',{on:{"changeTips":_vm.changeTips}}),_c('RightBoxVue')],1),_c('BottomBoxVue'),_c('TopTips',{attrs:{"tips":_vm.tips}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }